import React from 'react';
import Collapse from '@material-ui/core/Collapse';
import Grid from '@material-ui/core/Grid';
import DataTypeButton from './DataTypeButton';
import EditQueryName from './EditQueryName';
import RunAndSave from './RunAndSave';
import DefineQuery from './DefineQuery';
import RelatedDataType from '../RelatedData/RelatedData';
import { useSelector } from 'react-redux';
import { StyledGrid, StyledGridItem } from './CustomQueryHeaderStyle';

const CustomQueryHeader = () => {
  const hideCard = useSelector(state => state.customQueryHeader.hideCard);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledGrid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(EditQueryName, null)), /*#__PURE__*/React.createElement(StyledGridItem, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(RunAndSave, null))), /*#__PURE__*/React.createElement(Collapse, {
    in: !hideCard
  }, /*#__PURE__*/React.createElement(DataTypeButton, null), /*#__PURE__*/React.createElement(RelatedDataType, null), /*#__PURE__*/React.createElement(DefineQuery, null)));
};

export default CustomQueryHeader;